const pre = 'IMPACT_CHART';

export const INITIALISED = `${pre}/INITIALISED`;
export const SET_INITIALISED = `${pre}/SET_INITIALISED`;

export const initialised = () => ({
    type: INITIALISED
});

export const setInitialised = () => ({
    type: SET_INITIALISED
});

export const FETCH_IM_MONITORING_REQUEST = `${pre}/FETCH_IM_MONITORING_REQUEST`;
export const FETCH_IM_MONITORING_SUCCESS = `${pre}/FETCH_IM_MONITORING_SUCCESS`;
export const FETCH_IM_MONITORING_ERROR = `${pre}/FETCH_IM_MONITORING_ERROR`;

export const fetchImMonitoringRequest = () => ({
    type: FETCH_IM_MONITORING_REQUEST
});

export const fetchImMonitoringSuccess = (data, timestamp) => ({
    type: FETCH_IM_MONITORING_SUCCESS,
    data,
    timestamp
});

export const fetchImMonitoringError = message => ({
    type: FETCH_IM_MONITORING_ERROR,
    message
});

export const REFRESH_DATA = `${pre}/REFRESH_DATA`;

export const refreshData = () => ({
    type: REFRESH_DATA
});

export const SWITCH_CURRENCIES = `${pre}/SWITCH_CURRENCIES`;

export const switchCurrencies = () => ({
    type: SWITCH_CURRENCIES
});

export const SET_SORTING = `${pre}/SET_SORTING`;

export const setSorting = sorting => ({
    type: SET_SORTING,
    sorting
});

export const REFRESH_CSACHART = `${pre}/REFRESH_CSACHART`;

export const refreshCsaChart = () => ({
    type: REFRESH_CSACHART,
});
